export const articles = [
  {
    slug: "edifact-excel-konvertieren",
    title: "EDIFACT in Excel umwandeln – gratis & ohne Software (in 60 Sekunden)",
    excerpt: "👉 Wandeln Sie EDIFACT-Dateien kostenlos in Excel um – direkt im Browser, ohne Installation. Schnell & für viele Formate geeignet.",
    image: "/blog/edifact-header.jpg"
  },
  {
    slug: "edifact-vs-software",
    title: "Online-Tool oder Desktop-Software? So findest du die beste Lösung für EDIFACT-Konvertierung",
    excerpt: "📊 Du willst EDIFACT-Dateien in Excel, CSV oder XML konvertieren – aber welches Tool passt besser zu dir? Hier erfährst du die wichtigsten Unterschiede zwischen Online-Konvertern und Desktop-Lösungen – mit klarer Empfehlung für deinen Anwendungsfall.",
    image: "/blog/edifact-vs-software.jpg"
  },
  {
    slug: "edifact-was-ist",
    title: "EDIFACT erklärt in 2 Minuten – endlich verständlich für alle",
    excerpt: "👇 Endlich verständlich: Was ist EDIFACT und warum wird es überall genutzt? In 2 Minuten weißt du, worauf es ankommt – mit anschaulichem Beispiel.",
    image: "/blog/was-ist-edifact.jpg"
  },

  {
  slug: "edifact-tool-funktionen",
  title: "Was kann der EDI-Konverter wirklich? Die Top-Funktionen im Check (2025)",
  excerpt: "✅ Die wichtigsten Funktionen des EDI-Konverters im Überblick – inkl. unterstützter Dateitypen & geplanter Features (Stand 2025).",
  image: "/blog/edifact-funktionen.jpg"
},

{
  slug: "edifact-nach-csv",
  title: "EDIFACT nach CSV? 3 Gründe dafür – und 1, warum du’s lassen solltest",
  excerpt: "📊 Wann lohnt sich der Export von EDIFACT nach CSV? Diese 3 Vorteile solltest du kennen – aber auch diesen entscheidenden Nachteil.",
  image: "/blog/edifact-csv-export.jpg"
},

{
  slug: "edifact-datei-oeffnen",
  title: "EDIFACT-Dateien öffnen & konvertieren – gratis Anleitung für 2025 (ohne Installation)",
  excerpt: "📂 So öffnest, liest und konvertierst du EDIFACT-Dateien online – ohne Tools, kostenlos & sicher. Ideal für Excel, CSV & mehr.",
  image: "/blog/edifact-datei-oeffnen.jpg"
},

{
  slug: "edifact-xml-konvertieren",
  title: "EDIFACT in XML umwandeln – in 60 Sekunden (für Entwickler & B2B-Prozesse",
  excerpt: "🔁 Wandeln Sie EDIFACT in XML – ideal für APIs, B2B-Integrationen & Automatisierung. Mit Gratis-Tool, Anleitung & Praxisbeispiel.",
  image: "/blog/edifact-xml.jpg"
},
{
  slug: "edifact-json-konvertieren",
  title: "EDIFACT nach JSON – So wandelst du EDI-Daten in 60 Sek. um (mit Beispiel)",
  excerpt: "🧩 Schnell und kostenlos: So konvertierst du EDIFACT ins JSON-Format – ideal für Entwickler, APIs & Echtzeitdaten.",
  image: "/blog/edifact-json.jpg"
},
{
  slug: "edifact-segmente-erklaert",
  title: "Verstehst du diese EDIFACT-Segmente? Klartext mit Beispielen & Tipps",
  excerpt: "🔍 Segmentchaos? Nicht mit uns! Hier lernst du, wie EDIFACT-Segmente aufgebaut sind – inkl. realer Beispiele & Profi-Tipps.",
  image: "/blog/edifact-segmente.jpg"
},
{
  slug: "edifact-mit-sap-nutzen",
  title: "EDIFACT & SAP – So gelingt die Integration reibungslos (inkl. Beispiel)",
  excerpt: "🔧 EDIFACT-Dateien direkt in SAP nutzen: Import, Anzeige & Verarbeitung – Schritt für Schritt erklärt mit echten SAP-Praxistipps.",
  image: "/blog/edifact-sap.jpg"
},
{
  slug: "edifact-validierung-fehler",
  title: "So vermeidest du typische EDIFACT-Fehler – inkl. Schnell-Check & Lösungen",
  excerpt: "⚠️ Zeichensatzfehler, ungültige Segmente & Co.? So findest du die häufigsten Validierungsprobleme – und behebst sie direkt.",
  image: "/blog/edifact-validierung.jpg"
},

{
  slug: "edifact-vda-unterschiede",
  title: "EDIFACT vs. VDA – Welches Format ist 2025 das Richtige für dich?",
  excerpt: "⚙️ Zwei Standards, viele Unterschiede: EDIFACT oder VDA? Finde heraus, welcher besser zu deiner Branche und IT passt.",
  image: "/blog/edifact-vda.jpg"
},
{
  slug: "edifact-orders-bestellung",
  title: "So funktioniert EDIFACT ORDERS – mit Bestellbeispiel & Anleitung",
  excerpt: "🛒 Was steckt hinter EDIFACT ORDERS? So läuft der Bestellprozess elektronisch – mit praktischem Beispiel und Erklärung.",
  image: "/blog/edifact-orders.jpg"
},

{
  slug: "edifact-desadv-lieferavis",
  title: "Was ist ein Lieferavis? EDIFACT DESADV einfach erklärt (inkl. Anwendung)",
  excerpt: "📦 Lieferavis senden leicht gemacht: So funktioniert EDIFACT DESADV – mit Aufbau, Nutzen und Umwandlung in Excel oder CSV.",
  image: "/blog/edifact-desadv.jpg"
},
{
  slug: "edifact-fehlerquellen",
  title: "Die 7 häufigsten EDI-Probleme – und wie du sie sofort löst (Fehler-Check)",
  excerpt: "⚠️ Fehler beim Import? Diese 7 EDI-Probleme treten am häufigsten auf – plus konkrete Lösungen, wie du sie in Minuten behebst.",
  image: "/blog/edifact-fehlerquellen.jpg"
},
{
  slug: "edifact-beispiel",
  title: "EDIFACT-Beispiele erklärt – ORDERS, INVOIC & DESADV im Klartext (mit Segment-Analyse)",
  excerpt: "📂 So sind ORDERS, INVOIC & DESADV wirklich aufgebaut: Verstehe EDIFACT-Nachrichten anhand realer Beispiele – Segment für Segment einfach erklärt.",
  image: "/blog/edifact-beispiel-header.jpg"
},
{
  slug: "edifact-nachrichtentypen",
  title: "Diese EDIFACT-Nachrichtentypen musst du kennen – inkl. Beispiele & Schnell-Übersicht",
  excerpt: "📑 ORDERS, INVOIC, DESADV & mehr: Verstehe die wichtigsten EDIFACT-Nachrichtentypen – kompakt erklärt mit Beispielen & Schnell-Übersicht zum Nachschlagen.",
  image: "/blog/edifact-nachrichtenarten-header.jpg"
},
{
  slug: "edifact-viewer",
  title: "EDIFACT Viewer – EDI-Dateien öffnen – mit dem kostenlosen Viewer online",
  excerpt: "👓 EDI-Dateien anzeigen leicht gemacht: Der kostenlosen EDIFACT Viewer im Detail – inklusive Online-Tools & Software-Tipps.",
  image: "/blog/viewer-header.jpg"
}

















  // ... weitere Artikel
];
